import React from "react";
import "./About.css";
import CV from "../assets/IMAN's Resume.pdf";
import MovingText from "react-moving-text";
import { IoMdDownload } from "react-icons/io";
import Skills from "../Skills/Skills";
import Experience from "../Qualifications/Qualifications";
import Transition from "../Transition/Transition";

function About() {
  return (
    <div id="about" className="about-container">
      <Transition />
      <div className="section">
        <h1>
          <MovingText
            type="fadeInFromBottom"
            duration="1500ms"
            delay="0s"
            direction="normal"
            timing="ease"
            iteration="1"
            fillMode="none"
          >
            The Personal Side
          </MovingText>
        </h1>
        <MovingText
          type="fadeInFromBottom"
          duration="1500ms"
          delay="0s"
          direction="normal"
          timing="ease"
          iteration="1"
          fillMode="none"
        >
          <div className="box">
            <div className="about-me">
              <h3>Biography</h3>

              <p className="about-text">
                My name is Iman Allahverdiyev, born and raised in Baku,
                Azerbaijan and currently based in Lodz, Poland. I'm a Frontend
                Web Developer, my passion lies in building the Front-end of
                Websites that leads to the success of the overall product. I
                have 1 Year of experience in the industry and have worked with
                several clients from various industries.
                <br />
                <br />I am currently open to Job opportunities where I can
                contribute, learn and grow. If you have a good opportunity that
                matches my skills and experience, please don't hesitate to
                contact me. Thank you for taking the time to read my profile!
              </p>

              <div className="info-links">
              
                <a
                  className="contact-btn"
                  target="_blank"
                  href="mailto:imoallahverdiyev14@gmail.com"
                >
                  Contact
                </a>
              </div>
            </div>

            <div>
              <img className="about-img" src="p.jpeg" alt="" />
            </div>
          </div>
        </MovingText>
        <Skills />
        <Experience />
      </div>
    </div>
  );
}

export default About;
